import { IonModal } from "@ionic/react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  allExercisesState,
  duplicateExercisePlanState,
  fixedAllExercisesState,
  isDuplicateCalledState,
  // reviewPageListOfExercisesState,
} from "../data/atoms";
import PreviousExerciseModal from "./modals/PreviousExerciseModal";
import { useRecoilState, useRecoilValue } from "recoil";

interface Props {
  assesements: any;
}

const ExerciseSlider: React.FC<Props> = ({ assesements }) => {
  let history = useHistory();
  const [selectedExercisePlan, setSelectedExercisePlan] = useState({});
  const [previousExerciseModal, setPreviousExerciseModal] = useState(false);
  const [duplicateExercisePlan, setDuplicateExercisePlan] = useRecoilState(
    duplicateExercisePlanState
  );
  const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
    isDuplicateCalledState
  );
  const allExercises = useRecoilValue(allExercisesState);
  const [fixedExercisesCount, setFixedExercisesCount] = useRecoilState(
    fixedAllExercisesState
  );
  // const [reviewPageListOfExercises, setReviewPageListOfExercises] =
  //   useRecoilState(reviewPageListOfExercisesState);

  const showExercisePlanModal = (plan: any) => {
    setSelectedExercisePlan(plan);
    setPreviousExerciseModal(true);
  };

  const duplicateExercisePlanHandler = (
    exercisesId: string,
    recommendationDate: string
  ) => {
    debugger;

    // setReviewPageListOfExercises((prevState: any) => ({
    //   ...prevState,
    //   exercises: [],
    // }));

    setIsDuplicateCalled(true);
    let unionArray: any = [];

    // Create a new array containing the duplicate card exercises
    const filterId = exercisesId.split(",").map(Number);

    // Create a new array containing the previously selected exercises of that day
    if (fixedExercisesCount.previouslySelectedExercises != null) {
      const previousSelectedId =
        fixedExercisesCount.previouslySelectedExercises;
      const responseExerciseIds = previousSelectedId.map(
        (exercise: any) => exercise.testExercises[0].id
      );
      unionArray = Array.from(new Set([...filterId, ...responseExerciseIds]));
    } else {
      unionArray = filterId;
    }

    localStorage.setItem("selectedExercises", JSON.stringify(unionArray));
    const filteredList = allExercises.exercises.filter((item: any) =>
      unionArray.includes(item.testExercises[0].id)
    );
    setDuplicateExercisePlan((prevState: any) => ({
      ...prevState,
      exercises: filteredList,
    }));
    debugger;
    let visitId = 0;
    assesements.map((exercise: any) => {
      if (exercise.exercisesId.includes(exercisesId)) {
        visitId = exercise.visitId;
      }
    });
    const combinedObject = {
      visitId: visitId,
      exercisesRecommendationHistory: assesements,
      recommendationDate: recommendationDate,
    };
    history.push("/duplicate-exercise", {
      visitData: combinedObject,
    });
  };

  return (
    <>
      <IonModal
        className=" all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={previousExerciseModal}
        placeholder={undefined}
      >
        <PreviousExerciseModal
          selectedExercisePlan={selectedExercisePlan}
          setPreviousExerciseModal={setPreviousExerciseModal}
        ></PreviousExerciseModal>
      </IonModal>
      <Swiper slidesPerView={"auto"} spaceBetween={13}>
        {assesements.map((exercise: any, index: any) => {
          return (
            <SwiperSlide key={index}>
              <div className="previous-exercises-slider-wrap">
                <div className="previous-exercises-slider">
                  <div className="previous-exercises-slider-top-sec">
                    <h2>{exercise.recommendationDateToDisplay}</h2>
                    <div onClick={() => showExercisePlanModal(exercise)}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="9.05"
                          fill="white"
                          stroke="#31344E"
                          strokeWidth="1.9"
                        />
                        <path
                          d="M10.508 12.3391H8.46477C8.47011 11.8583 8.50751 11.4444 8.57695 11.0971C8.65173 10.7446 8.77727 10.4267 8.95355 10.1436C9.13517 9.8605 9.37555 9.58006 9.6747 9.30228C9.92576 9.07793 10.1448 8.86425 10.3317 8.66126C10.5187 8.45827 10.6656 8.24994 10.7724 8.03627C10.8793 7.81725 10.9327 7.5742 10.9327 7.30711C10.9327 6.99728 10.8846 6.74088 10.7885 6.53789C10.6977 6.32956 10.5588 6.17197 10.3718 6.06513C10.1902 5.9583 9.96048 5.90488 9.68271 5.90488C9.45301 5.90488 9.23934 5.95563 9.04169 6.05712C8.84404 6.15327 8.68111 6.30285 8.55291 6.50584C8.43005 6.70883 8.36595 6.97592 8.36061 7.30711H6.03691C6.05293 6.57528 6.2212 5.97165 6.54171 5.49623C6.86756 5.01547 7.30292 4.66023 7.84779 4.43053C8.39266 4.19549 9.0043 4.07797 9.68271 4.07797C10.4306 4.07797 11.0716 4.20084 11.6058 4.44656C12.1399 4.68694 12.5486 5.04217 12.8317 5.51226C13.1148 5.97699 13.2564 6.54323 13.2564 7.21096C13.2564 7.6757 13.1656 8.08969 12.984 8.45293C12.8023 8.81084 12.5646 9.1447 12.2708 9.45453C11.977 9.76435 11.6538 10.0849 11.3013 10.4161C10.9968 10.6885 10.7885 10.9743 10.6763 11.2734C10.5695 11.5726 10.5134 11.9278 10.508 12.3391ZM8.22439 14.8151C8.22439 14.4732 8.34191 14.1901 8.57695 13.9657C8.81199 13.736 9.12716 13.6212 9.52245 13.6212C9.91241 13.6212 10.2249 13.736 10.4599 13.9657C10.7003 14.1901 10.8205 14.4732 10.8205 14.8151C10.8205 15.1462 10.7003 15.4267 10.4599 15.6564C10.2249 15.8861 9.91241 16.0009 9.52245 16.0009C9.12716 16.0009 8.81199 15.8861 8.57695 15.6564C8.34191 15.4267 8.22439 15.1462 8.22439 14.8151Z"
                          fill="#31344E"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    <strong>{exercise.totalExercises} Exercises</strong>
                  </h3>
                  <h5>
                    <span>{exercise.exercisesNames[0]}</span>
                  </h5>
                  {exercise.exercisesNames.length >= 2 && (
                    <h5>
                      <span>{exercise.exercisesNames[1]}</span>{" "}
                      {exercise.totalExercises - 2 > 0 && (
                        <strong>
                          <u onClick={() => showExercisePlanModal(exercise)}>
                            + {exercise.totalExercises - 2} more
                          </u>
                        </strong>
                      )}
                    </h5>
                  )}
                  <button
                    className="view-visit"
                    onClick={() =>
                      duplicateExercisePlanHandler(
                        exercise.exercisesId,
                        exercise.recommendationDate
                      )
                    }
                  >
                    Duplicate Exercises
                  </button>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};
export default ExerciseSlider;
